import { Component, input } from '@angular/core';

@Component({
  selector: 'modal-icon',
  imports: [],
  templateUrl: './modal-icon.component.html',
  styleUrl: './modal-icon.component.scss'
})
export class ModalIconComponent {
  preset = input<ModalIconType>();
  bi_icon = input<string>();
  type = input<ModalIconType>('default');
  size = input<'sm' | 'md' | 'lg'>('md');

  getIcon() {
    if (this.preset()) {
      switch (this.preset()) {
        case 'success': return { icon: 'bi-check-circle', type: 'success' };
        case 'warning': return { icon: 'bi-exclamation-triangle', type: 'warning' };
        case 'danger': return { icon: 'bi-exclamation-triangle', type: 'danger' };
        case 'info':
        case 'default':
            return { icon: 'bi-exclamation-circle', type: 'info' };
      }
    }
    return { icon: this.bi_icon(), type: this.type() };
  }
}

export type ModalIconType =
'success' |
'info' |
'warning' |
'danger' |
'default'
